import(/* webpackMode: "eager" */ "/vercel/path0/app/(chat)/error.tsx");
